import { useTranslation } from "next-i18next";
import Image from "next/image";
import { useAppDispatch } from "@/store/hooks";
import { setProductAttrSelectVisible } from "@/store/mobilePopup";
import Icon from "@/components/Icon";

/**
 * mobile product specification select
 * @param attrsLen optional specification length
 * @param attrSelectArr selected product specifications
 */
const MobileAttrSelect = ({
  attrsLen,
  attrSelectArr,
}: {
  attrsLen: number;
  attrSelectArr: string[];
}) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  /**
   * open or close popup
   * @param visible boolean popup visible
   */
  const handlePopupVisible = (visible: boolean) => {
    dispatch(setProductAttrSelectVisible(visible));
  };

  return (
    <div
      className="mt-4 flex w-full	items-start border-t border-gray-100 pt-4 text-sm text-stone-800 lg:hidden"
      onClick={() => {
        handlePopupVisible(true);
      }}
      data-qt="mall_detail_spec_popup_open"
      data-qt-attrs-len={attrsLen}
      data-qt-has-selected={attrSelectArr?.length ? 1 : 0}
    >
      <div className="flex-shrink-0">{t("mobile.selected")}:</div>

      <div className="mx-4 flex flex-1 flex-col">
        {attrSelectArr && attrSelectArr.length > 0 ? (
          <div className="mb-4">
            {attrSelectArr.map(
              (attr, attrIndex) =>
                `${attr}${attrIndex < attrSelectArr.length - 1 ? "; " : ""}`
            )}
          </div>
        ) : (
          <div className="mb-4 text-stone-100">
            {t("product_detail.please_select_product_info")}
          </div>
        )}

        <div className="flex items-center justify-center self-baseline break-all rounded-md bg-gray-200 p-2 text-xs">
          {`${t("mobile.total")} ${attrsLen} ${t(
            "mobile.configurations_are_optional"
          )}`}
        </div>
      </div>
      <Icon name="arrow-right" isMobile size={16} className="flex-shrink-0" />
    </div>
  );
};

export default MobileAttrSelect;
